module.exports = __webpack_public_path__ + "img/woodtexture.be10027b.png";